var config = {
  storage_base_url: "https://matrix-production1.s3.amazonaws.com/",
  api_url: 'https://disbursement.matrixbscloud.com/apis/api',
};

export default config;
